module.exports = __webpack_public_path__ + "static/img/8.a0cd3f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imges/3Dmodeling/8.jpg
// module id = YCwv
// module chunks = 1